<template>
  <div>
    <container-headline
      :headline="$t('global.otherimportantinformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="person.personenangaben.bildungseinrichtung"
                  label="bezeichnung"
                  :options="bildungseinrichtungen"
                  :reduce="
                    (option) => ({
                      id: option.id,
                      bezeichnung: option.bezeichnung,
                    })
                  "
                  :disabled="!editable"
                  :placeholder="$t('portal.school')"
                />
                <label>{{ $t("portal.school") }}</label>
              </div>
            </div>
            <div
              class="col-xl-6"
              v-if="person.personenangaben.bildungseinrichtung?.id === '19BEB083A76'"
            >
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.personenangaben.anderePartnerschule"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("portal.otherPartnerSchool") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="person.weitereAngaben.ernaehrung"
                  label="bezeichnung"
                  :options="ernaehrungen"
                  :reduce="
                    (option) => ({
                      id: option.id,
                      bezeichnung: option.bezeichnung,
                    })
                  "
                  :disabled="!editable"
                  :placeholder="$t('global.nutrition')"
                />
                <label>{{ $t("global.nutrition") }}</label>
              </div>
            </div>
            <div
              class="col-xl-6"
              v-if="person.weitereAngaben.ernaehrung?.id === '1961451788D'"
            >
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.andereErnaehrung"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.othernutrition") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.allergienUnvertraeglichkeiten"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.allergiesintolerances") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.regelmaessigeMedikamente"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.medication") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.gesundheitlicheBeschwerden"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.healthcomplaints") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.sonstiges"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{
                    $t("global.otherusefultipsforthefarmingfamily")
                  }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="person.weitereAngaben.interneBemerkungen"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.internalcomments") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import AppApi from "@/api/AppApi";
import PublicAppApi from "@/api/PublicAppApi";

export default {
  name: "GeschaeftsparnerWeitereWichtigeAngabenNewViva",
  components: {
    ContainerHeadline
  },
  mixins: [],
  props: {
    person: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      ernaehrungen: [
        { id: "19614515C75", bezeichnung: this.$t("global.meat") },
        { id: "19614511B32", bezeichnung: this.$t("global.vegetarian") },
        { id: "19614513581", bezeichnung: this.$t("global.vegan") },
        { id: "1961451788D", bezeichnung: this.$t("global.other") }
      ],
      bildungseinrichtungen: []
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    if (this.bildungseinrichtungen.length === 0) {
      PublicAppApi.get("/auswahlwerte/agriviva", {
        params: { lang: this.$i18n.locale }
      }).then((response) => {
        this.bildungseinrichtungen = response.data.partnerschulen;
      });
    }
  },
  methods: {}
};
</script>
